import { apiFetch } from '@/lib/api-client';

/**
 * Public-list shape returned by `GET /api/story-worlds` (the
 * `@Public` endpoint in `StoryWorldsController.findAll`). The
 * backend service spreads the language-translation row into the
 * response — the PWA only consumes the identity fields below
 * (`id`, `slug`) for slug→UUID resolution. The remaining fields
 * are included for forward compatibility but typed as optional.
 */
export interface StoryWorldPublic {
  id: string;
  slug: string;
  productLine: string;
  sortOrder: number;
  usesStuffedAnimal?: boolean;
  usesFriends?: boolean;
  usesFamilyMembers?: boolean;
  usesCustomTheme?: boolean;
  requiresFamilyProfile?: boolean;
  showRating?: boolean;
  showShare?: boolean;
  showLearning?: boolean;
  name?: string;
  description?: string;
  tagline?: string;
}

/**
 * Fetch the public list of active story worlds. Used by LibraryRoute
 * to build a slug→UUID map for the world-chip filter (the backend
 * `ListStoriesQueryDto.worldIds` validator is `@IsUUID('4')` — sending
 * synthetic slugs like `world-aa` is rejected with 400).
 *
 * Default language is `de`. Public endpoint — no auth header required,
 * but `apiFetch` attaches the bearer if a session exists; the backend
 * ignores it for this route.
 */
export function fetchWorlds(language = 'de'): Promise<StoryWorldPublic[]> {
  return apiFetch<StoryWorldPublic[]>(`/api/story-worlds?language=${encodeURIComponent(language)}`);
}
